import { AnchorHTMLAttributes } from 'react';
import Anchor from '../../components/anchor';
import useArticle from '../../lib/use-article';

export default function A(props: AnchorHTMLAttributes<HTMLAnchorElement>) {
    const article = useArticle();

    return <Anchor {...props} base={article} />;
}
